import $ from 'jquery'

var setOp = {
  SetSelect2() {
    $(`.select2`).attr(`style`, `width: 100% !important`)
  },
  hideLoader() {
    $(`body`).removeClass(`vld-shown`)
    $(`.vld-overlay`).parent().remove()
  },
  getCompanyId(url) {
    var array = url.split(`-`)
    return array[array.length - 1]
  },
  getProductName(url) {
    var array = url.split(`-`)
    array = array.splice(0, array.length - 1)
    return array.join(' ').toUpperCase()
  },
  getLangCode() {
    var langCode = window.location.pathname.split('/')[1]
    if (langCode == '' || langCode == undefined || langCode == null) {
      return 'en'
    }

    return langCode
  },
  setCoverImage(url) {
    $(`#app`).attr(`style`, `background-image: url('https://cdn.turkishexporter.com.tr${url}')`)
  },
  setCookie(name, value, days) {
    var expires = ''
    if (days) {
      var date = new Date()
      date.setTime(date.getTime() + days * 24 * 60 * 60 * 1000)
      expires = '; expires=' + date.toUTCString()
    }
    document.cookie = name + '=' + (value || '') + expires + '; path=/'
  },
  getCookie(name) {
    var nameEQ = name + '='
    var ca = document.cookie.split(';')
    for (var i = 0; i < ca.length; i++) {
      var c = ca[i]
      while (c.charAt(0) == ' ') c = c.substring(1, c.length)
      if (c.indexOf(nameEQ) == 0) return c.substring(nameEQ.length, c.length)
    }
    return null
  },
  setLocalStorage(name, value) {
    localStorage.setItem(name, value)
  },
  getLocalStorage(name) {
    return localStorage.getItem(name)
  },
  zoomImage() {
    $(`.gFirstImage`).click()
  },
  stripHtml(text) {
    var html = text
    var div = document.createElement('div')
    div.innerHTML = html
    var strippedText = div.textContent || div.innerText || ''

    return strippedText
  },
  clearHtml(html) {
    var temporalDivElement = document.createElement('div')
    // Set the HTML content with the providen
    temporalDivElement.innerHTML = html
    // Retrieve the text property of the element (cross-browser support)
    return (
      temporalDivElement.textContent /*.replace("<script", "[script")*/ ||
      temporalDivElement.innerText /*.replace("<script", "[script")*/ ||
      ''
    )
  }
}

export default setOp
